module.exports = __webpack_public_path__ + "img/logotipo.3b7c4201.svg";